export interface Profile {
    id: number;
    user_id: string | null; // Foreign key to User
    name: string;
    email: string;
    phone: string;
    address: string;
    country: string;
    city: string;
    postcode: string;
    created_at: string;
    updated_at: string;
    user_type: UserType;
}

export enum UserType {
    SUPER_ADMIN = 'super_admin',
    BUSINESS = 'business',
    USER = 'user',
}
